import isEqual from "lodash/isEqual";
export const IsFormDataChanged = (
  initialFormData: any,
  updatedFormData: any
) => {
  return !isEqual(initialFormData, updatedFormData);
};
